import { render } from "./PUseStatusButton.vue?vue&type=template&id=386e5f40&scoped=true"
import script from "./PUseStatusButton.vue?vue&type=script&lang=js"
export * from "./PUseStatusButton.vue?vue&type=script&lang=js"

import "./PUseStatusButton.vue?vue&type=style&index=0&id=386e5f40&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-386e5f40"

export default script